import http from './httpService';
import * as Axios from 'axios';
import {appModules} from '../utils/const';
import {getLanguage} from 'react-switch-lang';

// Part same as incurred risk
export function GetPotentionalRisk(id) {
  return http.get(`risks?riskTypeId.equals=1&id.equals=${id}`);
}
export function getPotentionalRisks() {
  return http.get('/risks?riskTypeId.equals=1');
}

export function getAllSubProcesses(processId, page = 0, size = 20) {
  return http.get(`/subprocesses?processId.equals=${processId}&page=${page}&size=${size}&active.equals=true`);
}

export function getAllSubCategories(categoryId, page = 0, size = 20, search = '') {
  let url = (`/court-subcategory-risks-by-category/${categoryId}?page=${page}&size=${size}`);
  if (search) {
    url += getLanguage() === 'eng'
      ? `&nameEn.contains=${search}`
      : `&name.contains=${search}`;
  }

  return http.get(url);
}

export function getLitigation(litigationId) {
  return http.get(`/court-risks/${litigationId}`);
}
export function getSubjectStatus() {
  return http.get('/court-risks/subject-statuses');
}

export function addLitigation(data, files) {
  const formData = new FormData();
  formData.append('courtRiskDTO', JSON.stringify(data));
  for (let i = 0; i < files.length; i++) {
    formData.append('files', files[i]);
  }

  return Axios({
    method: 'post',
    url: '/court-risks',
    data: formData,
    headers: {'Content-Type': 'multipart/form-data;'},
  });
}

export function editLitigation(data, files) {
  const formData = new FormData();
  formData.append('courtRiskDTO', JSON.stringify(data));
  for (let i = 0; i < files.length; i++) {
    formData.append('files', files[i]);
  }

  return Axios({
    method: 'put',
    url: '/court-risks',
    data: formData,
    headers: {'Content-Type': 'multipart/form-data;'},
  });
}

export function getRiskFile(fileId, fileName) {
  return Axios({
    url: `/file/download/${fileId}`, //your url
    method: 'get',
    responseType: 'blob', // important
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    // link.target = "_blank"
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  });
}

export function getAllSubCauses(riskCauseId, page = 0, size = 20) {
  return http.get(`risk-sub-causes?riskCauseId.equals=${riskCauseId}&page=${page}&size=${size}`);
}

export function getDepartmentsLoginUser() {
  return http.get(`departments-login-user?moduleId=${appModules?.riskModule}`);
}
